import React from "react";
import { useQuery } from "@apollo/react-hooks";
import { gql } from "apollo-boost";

import ErrorPage from "commonComponents/errorPage/ErrorPage";
import PageHeader from "designV2/components/PageHeader";
import { Skeleton } from "designV2/components/Skeleton";
import AddAdvertisement from "./AddAdvertisement";
import "../superAds.css";

const GET_ADVERTISEMENT = gql`
  query getSingleAdvertisement($id: ID!) {
    getSingleAdvertisement(id: $id) {
      _id
      title
      description
      startAt
      endAt
      redirectTo
      photoUrl
    }
  }
`;

const EditAdvertisement = (props) => {
  const { loading, error, data } = useQuery(GET_ADVERTISEMENT, {
    variables: { id: props.match.params.id },
    fetchPolicy: "network-only",
  });

  if (loading) {
    return (
      <div className="page superAdsPage">
        <main className="main">
          <PageHeader title="Edit advertisement" />
          <Skeleton height={220} />
          <Skeleton height={220} />
        </main>
      </div>
    );
  }

  if (error || !data || !data.getSingleAdvertisement) {
    return <ErrorPage />;
  }

  return <AddAdvertisement advertisement={data.getSingleAdvertisement} />;
};

export default EditAdvertisement;
